import { httpDelete, httpGet, httpPatch, httpPost } from "../../connection.js";

const get = async (values = {}) => {
  return httpGet("/analysis/artifacts", values);
};

const create = async (values = {}) => {
  return httpPost("/analysis/artifacts", values);
};

const update = async (values = {}) => {
  return httpPatch(`/analysis/artifacts/${values.uuid}`, values);
};

const remove = async (values = {}) => {
  return httpDelete(`/analysis/artifacts/${values.uuid}`);
};

const ArtifactsAPI = {
  get,
  create,
  update,
  remove,
};

export default ArtifactsAPI;
